import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { HttpClient } from '@angular/common/http';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class KeycloakAuthGuardService extends KeycloakAuthGuard {
  
  private _activatedRoute! : ActivatedRoute;

  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private client : HttpClient,
    private activatedRoute : ActivatedRoute
  ) 
  {
      super(router, keycloak);
      this._activatedRoute = activatedRoute;
  
    }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) 
  {
      var routeUrl : string = route.data["url"];
       // Force the user to log in if currently unauthenticated.
      if (!this.authenticated) {
        await this.keycloak.login({redirectUri: window.location.origin + state.url});
      }

      var sideNavRoles;
      var keycloakToken = await this.keycloak.getToken()
      .then((token)=> {
        sideNavRoles = jwtDecode(token)['sitenav'];
      });
      if (!Array.isArray(sideNavRoles) || sideNavRoles.length === 0 ||sideNavRoles == undefined ) {
        return false;
      }

      if(!routeUrl){
        return false;
      }
      
      routeUrl = routeUrl.toLowerCase();
      return sideNavRoles.some((accessPath) => routeUrl?.toLowerCase() == accessPath?.toLowerCase());
  }

}
